export default __webpack_public_path__ + "static/media/mirrorLanding.0f138e79.svg";